export default __webpack_public_path__ + "static/media/logo_mini.146bf207.jpg";